import { render, staticRenderFns } from "./UserAddDialog.vue?vue&type=template&id=31204db8&scoped=true&"
import script from "./UserAddDialog.vue?vue&type=script&lang=js&"
export * from "./UserAddDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31204db8",
  null
  
)

export default component.exports